import React, { useEffect, useRef } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Button, Input } from 'antd';
import type { InputRef } from 'antd';

export const INTEGRATION_SEARCH_PLACEHOLDER = 'Search integrations';

export type IntegrationSearchProps = {
  readonly query: string;
  readonly onQueryChange: (query: string) => void;
  readonly collapsed?: boolean;
  readonly onExpand?: () => void;
};

export const IntegrationSearch = ({ query, onQueryChange, collapsed = false, onExpand }: IntegrationSearchProps) => {
  const inputRef = useRef<InputRef>(null);
  const expandedToType = useRef(false);

  // Expanding swaps the button for the field, so React unmounts the node the
  // keyboard was on. Without this a customer who activates the button is left
  // on <body>, tabbing from the top of the page to reach the field they asked for.
  useEffect(() => {
    if (!collapsed && expandedToType.current) {
      expandedToType.current = false;
      inputRef.current?.focus();
    }
  }, [collapsed]);

  if (collapsed) {
    return (
      <Button
        aria-label={INTEGRATION_SEARCH_PLACEHOLDER}
        icon={<SearchOutlined />}
        onClick={() => {
          expandedToType.current = true;
          onExpand?.();
        }}
      />
    );
  }

  return (
    <Input
      ref={inputRef}
      allowClear
      value={query}
      aria-label={INTEGRATION_SEARCH_PLACEHOLDER}
      placeholder={INTEGRATION_SEARCH_PLACEHOLDER}
      suffix={<SearchOutlined />}
      onChange={(event) => onQueryChange(event.target.value)}
    />
  );
};
